export const PoolCodes = {
  Win: 'Win',
  Trifecta: 'Trifecta',
  Quinella: 'Quinella',
  Exacta: 'Exacta',
}
